import ApiClient from '@src/lib/api_client'
import { API } from '@src/lib/api_path'
import Station from '@src/data/station'
import camelcaseKeys from 'camelcase-keys'
import SessionManager from '@src/lib/session_manager'
import { snakecaseKeys } from '@src/util/functions'

export class StationService {

  apiClient: ApiClient = new ApiClient()

  getAll (): Promise<Station[] | void> {
    return this.apiClient.get<any>(SessionManager.Instance.isManager() ? API.TRAINERS_API.STATIONS : API.MEMBERS_API.STATIONS)
      .then(response => {
        const stations = response.stations.map((attrs) =>
          new Station(camelcaseKeys(attrs))
        )
        return Promise.resolve(stations)
      })
      .catch(error => {
        console.error('failed to retrieve stations', error)
        return Promise.reject(error)
      })
  }

  edit (station) {
    return this.apiClient.put(`${API.TRAINERS_API.STATIONS}/${station.id}`, { station: snakecaseKeys(station) })
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error))
  }
}
